import { useAuth0 } from "@auth0/auth0-react";
import { Box, Button, Typography } from "@mui/material";
import React from "react";
import LogoIcon from "../components/LogoIcon";

export default function Verify() {
  const { logout } = useAuth0();
  const returnToLogIn = () => {
    logout({
      logoutParams: {
        returnTo: `${window.location.origin}`,
      },
    });
  };

  return (
    <Box
      sx={{
        flex: 1,
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <LogoIcon height={200} />
      <Typography sx={{ fontSize: 14, mt: 5 }}>
        Your email address has not yet been verified, please verify your email
        address and try again.
      </Typography>

      <Button onClick={returnToLogIn}>Return to log in</Button>
    </Box>
  );
}
